document.addEventListener('DOMContentLoaded', function() {
    // Sayfadaki tüm özellikleri gösteren slider elemanlarını seçiyoruz
    const featureSliders = document.querySelectorAll('.js-features-slider');

    featureSliders.forEach(function(sliderEl) {
        // Her bir slider'ın kendi ebeveyn (parent) wrapper'ını buluyoruz ki navigasyon butonları karışmasın
        const parentWrapper = sliderEl.closest('.relative');
        const nextBtn = parentWrapper ? parentWrapper.querySelector('.features-slider-nav-button.next') : null;
        const prevBtn = parentWrapper ? parentWrapper.querySelector('.features-slider-nav-button.prev') : null;

        // Swiper başlatılıyor
        new Swiper(sliderEl, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            
            // Responsive breakpoint ayarları
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                480: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
            },
            
            // Sadece bu slider'a ait olan butonları bağlıyoruz
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
                disabledClass: 'swiper-button-disabled',
            },
            
            speed: 300,
            effect: 'slide',
        });
    });
});